import { RenderOnlyProductsAndCustoms } from '../shared';

import { useSearchResult } from './hooks';

import type {
  FullMenuCatalog,
  IMenuCustomization,
  IMenuProduct,
} from 'features/menu-page/domain';

export function SearchResult(props: Props) {
  const {
    searchQuery,
    catalog,
    toggleOnOffProduct,
    toggleOnOffCustomization,
  } = props;

  const { lang, isLoading, products, customizations } = useSearchResult({
    searchQuery,
    catalog,
  });

  return (
    <RenderOnlyProductsAndCustoms
      title={lang.title + (isLoading ? ' ...Loading' : '')}
      ariaLabel='search-results'
      catalog={catalog}
      products={products}
      customizations={customizations}
      toggleOnOffProduct={toggleOnOffProduct}
      toggleOnOffCustomization={toggleOnOffCustomization}
    />
  );
}

interface Props {
  searchQuery: string;
  catalog: FullMenuCatalog;
  toggleOnOffProduct: (c: boolean, p: IMenuProduct) => void;
  toggleOnOffCustomization: (c: boolean, item: IMenuCustomization) => void;
}
